import type { RouteRecordRaw, Router } from 'vue-router'
import { useDevicePlatform } from '../Core/composables'
import useHotelSearchResultsStore from './store/hotelSearchResults'
import featureFlag from '@/config/featureFlag'

const INCLUDES_INDEX_PAGE = import.meta.env.VITE_INCLUDES_INDEX_PAGE

const SearchRoutes: RouteRecordRaw = {
  path: INCLUDES_INDEX_PAGE === 'true' ? '/search' : '',
  name: 'SearchModulePages',
  children: [
    {
      path: '',
      name: 'Search',
      component: () => import('./views/IndexPage.vue'),
      meta: {
        header: true,
      },
    },
    {
      path: '/result',
      name: 'Result',
      component: () => import('./views/ResultPage.vue'),
      meta: {
        showBottomNav: false,
      },
    },
    {
      path: '/hotels-map',
      name: 'HotelResultsMapView',
      beforeEnter: (_, __, next) => {
        const hotelSearchResultStore = useHotelSearchResultsStore()

        if (!hotelSearchResultStore.hotelsList.length) {
          next({ name: 'Search' })
        } else {
          next()
        }
      },
      component: () => import('./views/HotelResultsMapView.vue'),
      meta: {
        showBottomNav: false,
      },
    },
    {
      path: '/visa-details/:countryIso',
      name: 'VisaDetails',
      component: () => import('./views/VisaDetailsPage.vue'),
      meta: {
        showBottomNav: false,
      },
    },
    {
      path: '/curated-travel-journeys/:id',
      name: 'CuratedTravelJourneys',
      redirect: (to) => ({
        name: 'CuratedTravelJourneysTier',
        params: to.params,
      }),
      beforeEnter: (to, _, next) => {
        if (!featureFlag.curatedTrips.enabled) {
          next({ name: 'Search' })
          return
        }

        const { isMobile } = useDevicePlatform()

        to.meta.header = !isMobile.value

        next()
      },
      component: () => import('./views/CuratedTravelJourneysPage.vue'),
      children: [
        {
          path: '',
          name: 'CuratedTravelJourneysTier',
          component: () => import('./views/CuratedTravelJourneysTierPage.vue'),
          meta: {
            showBottomNav: false,
          },
        },
        {
          path: ':tierType/search',
          name: 'CuratedTravelJourneysSearch',
          component: () =>
            import('./views/CuratedTravelJourneysSearchPage.vue'),
        },
        {
          path: ':tierType/search-result',
          name: 'CuratedTravelJourneysSearchResult',
          component: () =>
            import('./views/CuratedTravelJourneysSearchResultPage.vue'),
          meta: {
            showBottomNav: false,
          },
        },
      ],
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(SearchRoutes)
}
